import { IService } from 'core/interfaces/Service'
import React, { useContext, useState } from 'react'
import { DarkThemeContext } from 'core/contexts/DarkThemeContext'
import { getIconeInfo } from 'core/utils/service'
import { FieldError } from 'react-hook-form'
import { IconComponent } from 'core/components/common/IconComponent'

export const ServiceCard: React.FC<{
  service: IService
  isSelected: boolean
  onClick: (service: IService) => void
  error: FieldError | undefined
}> = ({ service, isSelected, onClick, error }) => {
  const { isDarkTheme } = useContext(DarkThemeContext)
  const [isHovered, setIsHovered] = useState(false)
  const { colorBackground }: { colorBackground: string } = getIconeInfo(
    service.icone
  )

  return (
    <div
      onClick={() => onClick(service)}
      className="card service-card"
      style={{
        backgroundColor:
          isHovered || isSelected
            ? `${colorBackground}20`
            : isDarkTheme
              ? '#1C1C1C'
              : 'white',
        borderColor: error
          ? 'red'
          : isHovered || isSelected
            ? colorBackground
            : isDarkTheme
              ? '#4D5154'
              : '#EAEBEE',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <IconComponent
        iconInfo={service.icone}
        className="h-[40px] w-[40px] mt-10px"
      />
      <h3
        className="service-card-title"
        style={{ color: isHovered || isSelected ? colorBackground : 'inherit' }}
      >
        {service.nomService}
      </h3>
    </div>
  )
}
